import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { getTaskMail, updateTask } from '../../Redux/GetSlice';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTaskData } from '../../hooks/useTaskData';

export default function TaskDeadline({
    currentTaskId,
    setSelectedMyDayPlanDate,
    selectedMyDayPlanDate,
    handleUpdateTask,
    isOpen,
    onClose,
    taskItem,
    getTaskMail,
    handleDateSelect,
    isDeadlineChecked,
    setIsDeadlineChecked,
    clickedBellIcon
}) {
    const [customDate, setCustomDate] = useState(null);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    const {

        selectedMyDayPlanDate: reduxSelectedMyDayPlanDate,
        selectedReminderDate,
        selectedStatusNextStepDate,
        note,
        notesText,
        myDayDate,
        deadlineDate,
        isMyDayChecked,
        isDeadlineChecked: reduxIsDeadlineChecked,
        updateSelectedMyDayPlanDate: updateSelectedMyDayPlanDateRedux,
        updateSelectedReminderDate,
        updateSelectedStatusNextStepDate,
        updateNote,
        updateNotesText,
        updateMyDayDate,
        updateDeadlineDate,
        updateIsMyDayChecked,
        updateIsDeadlineChecked: updateIsDeadlineCheckedRedux,
        handleDateSelect: handleDateSelectFromHook,
        handleUpdateTask: handleUpdateTaskFromHook,
        resetAllTaskData,
    } = useTaskData();


    const formatToLocalISO = (date) => {
        const time = date.getTime()
        return formatEpochToISO(time);
    };
    const formatEpochToISO = (epochMillis) => {
        const date = new Date(epochMillis < 1e12 ? epochMillis * 1000 : epochMillis);
        return date.toISOString();
    };

    const formatDateForDisplay = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleString('en-US', {
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
    };


    const getFormattedDate = (dateOption) => {
        if (dateOption && typeof dateOption === 'object' && 'daysToAdd' in dateOption) {
            const date = new Date();
            date.setDate(date.getDate() + dateOption.daysToAdd);
            date.setHours(dateOption.time.hours, dateOption.time.minutes, 0, 0);
            return date;
        }

        return dateOption;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                if (onClose) {
                    onClose();
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    useEffect(() => {
        if (deadlineDate) {
            const date = new Date(deadlineDate);
            setCustomDate(date);
        }
    }, [deadlineDate]);

    const handleReminderSelection = (dateOption) => {
        const date = getFormattedDate(dateOption);
        const formattedDate = formatToLocalISO(date);
        updateDeadlineDate(formattedDate);
        handleUpdateTask(formattedDate, 'deadline', taskItem);

        if (onClose) {
            onClose();
        }
    };

    const handleDateChange = (date) => {
        setCustomDate(date);
        setShowDatePicker(false);
        handleReminderSelection(date);
    };

    const handleClearDeadline = () => {
        updateDeadlineDate(null);
        if (setSelectedMyDayPlanDate) {
            setSelectedMyDayPlanDate(null);
        }
        if (handleUpdateTask) {
            handleUpdateTask(null, 'deadline');
        } else {
            handleUpdateTaskFromHook(null, 'deadline', taskItem);
        }

        if (onClose) onClose();
    };

    const currentIsDeadlineChecked = reduxIsDeadlineChecked !== undefined ? reduxIsDeadlineChecked : isDeadlineChecked;
    const currentSetIsDeadlineChecked = updateIsDeadlineCheckedRedux || setIsDeadlineChecked;

    if (!isOpen) return null;
    const today = { daysToAdd: 0, time: { hours: 12, minutes: 0 } };
    const tomorrow = { daysToAdd: 1, time: { hours: 8, minutes: 0 } };
    const inTwoDays = { daysToAdd: 2, time: { hours: 8, minutes: 0 } };
    const nextWeek = { daysToAdd: 7, time: { hours: 8, minutes: 0 } };

    return (
        <div className="relative inline-block text-left" ref={dropdownRef}>
            {isOpen && (
                <div
                    className={`${clickedBellIcon ? 'fixed z-30' : '  z-30'}`}
                    style={clickedBellIcon ? { top: '50px', right: "2vw", minWidth: 260 } : { minWidth: 260, right: '2vw' }}
                >
                    <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-0" style={{ width: 260 }}>
                        <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200">
                            <span className="font-semibold text-sm text-gray-800">Deadline</span>
                            <button
                                className="text-blue-500 text-sm font-medium hover:underline"
                                onClick={handleClearDeadline}
                            >
                                Clear
                            </button>
                        </div>

                        <ul className="text-xs text-gray-800 divide-y divide-gray-100 px-0 mb-0">
                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(today)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-sun-fill text-gray-900"></i>
                                    <span className="text-xs">Later today</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(today))}
                                </span>
                            </li>

                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(tomorrow)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-moon-stars-fill text-gray-500"></i>
                                    <span className="text-xs">Tomorrow</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(tomorrow))}
                                </span>
                            </li>

                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(inTwoDays)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-clock-fill text-gray-500"></i>
                                    <span className="text-xs">In two days</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(inTwoDays))}
                                </span>
                            </li>

                            <li
                                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => handleReminderSelection(nextWeek)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-calendar-week-fill text-gray-500"></i>
                                    <span className="text-xs">Next week</span>
                                </span>
                                <span className="text-xs text-gray-500 font-medium">
                                    {formatDateForDisplay(getFormattedDate(nextWeek))}
                                </span>
                            </li>

                            <li
                                className="flex items-center px-2 py-2 cursor-pointer hover:bg-gray-50"
                                onClick={() => setShowDatePicker(!showDatePicker)}
                            >
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-calendar-event-fill text-gray-500"></i>
                                    <span className="text-xs">Pick a date</span>
                                </span>
                            </li>
                        </ul>

                        {showDatePicker && (
                            <div className="absolute left-1/2 top-0 mt-2 z-50 bg-white border border-gray-200 rounded shadow-lg" style={{ transform: 'translateX(-50%)', width: 320 }}>
                                <DatePicker
                                    selected={customDate}
                                    onChange={(date) => setCustomDate(date)}
                                    showTimeSelect
                                    timeFormat="hh:mm aa"
                                    timeIntervals={1}
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    placeholderText="Select date and time"

                                    inline
                                    minDate={new Date()}
                                />
                                <div className="flex  items-center mt-2 px-2" style={{ gap: '10px' }}>
                                    <button
                                        className="text-blue-600 text-xs font-medium hover:underline px-2 py-1 rounded"
                                        onClick={() => setCustomDate(new Date())}
                                        type="button"
                                    >
                                        ▼ Today
                                    </button>
                                    <button
                                        className="text-red-500 text-xs font-medium hover:underline px-2 py-1 rounded"
                                        onClick={() => setCustomDate(null)}
                                        type="button"
                                    >
                                        ✗ Clear
                                    </button>
                                    <button
                                        className="text-green-600 text-xs font-medium hover:underline px-2 py-1 rounded border border-green-600"
                                        onClick={() => {
                                            if (customDate) {
                                                handleDateChange(customDate);
                                            }
                                        }}
                                        type="button"
                                    >
                                        ✔ Save
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="px-4 py-3">
                            <label className="flex items-center gap-3 text-sm text-gray-700 cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="form-checkbox h-4 w-4 text-blue-500 rounded border-gray-300 focus:ring-blue-400"
                                    checked={currentIsDeadlineChecked}
                                    onChange={e => currentSetIsDeadlineChecked(e.target.checked)}
                                />
                                Also update the deadline date
                            </label>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
